@if (isLoading()) {
  <div class="loading-screen-overlay">
    <div class="loading-screen-content">
      <div class="spinner"></div>
      <p class="loading-message">{{ currentMessage() }}</p>
    </div>
  </div>
}

<router-outlet></router-outlet>
<mh-toaster></mh-toaster>
<mh-confirmation-modal></mh-confirmation-modal>
<mh-coachmark-overlay></mh-coachmark-overlay>
